<div class="_tenant-desktop-page">

    <segment-desktop-component [segments]="segments" [selectedSegment]="selectedSegment"
        (selectedSegmentChange)="onSelectedSegmentChange($any($event))"></segment-desktop-component>

    <ng-container [ngSwitch]="selectedSegment">

        <!-- Tenant details -->
        <div class="_segmented-component" *ngSwitchCase="getSegmentName(this.segments[0])">

            <div class="_container _tenant-details-container" *ngIf="tenantForm">
                <p class="_title" [translate]="'TENANT.DATA'"></p>
                <div class="_data-container">
                    <div class="_data _full">
                        <form-input label="{{ 'TENANT.NAME' | translate }}"
                            [formControl]="tenantForm.get('name') | cast"></form-input>
                    </div>
                    <div class="_data _full">
                        <form-textarea label="{{ 'TENANT.DESCRIPTION' | translate }}"
                            [formControl]="tenantForm.get('description') | cast"></form-textarea>
                    </div>
                </div>

                <p class="_small-title _small-sub-title" [translate]="'TENANT.IMAGES'"></p>
                <div class="_data-container _images-container">
                    <div class="_data _half">
                        <form-label label="{{'TENANT.LOGO' | translate}}"
                            [formControl]="tenantForm.get('logo') | cast"></form-label>
                        <div class="_upload-container">
                            <input name="file" id="file" type="file" class="file-input" accept='image/*'
                                (change)="addImageToForm('logo', $event)" label="SELECTEREN">
                            <div class="_image-container" *ngIf="tenantForm.get('logo').value">
                                <img [src]="tenantForm.get('logo').value" />
                            </div>
                        </div>
                    </div>
                    <div class="_data _half">
                        <form-label label="{{'TENANT.FAVICON' | translate}}"
                            [formControl]="tenantForm.get('favicon') | cast"></form-label>
                        <div class="_upload-container">
                            <input name="file" id="file" type="file" class="file-input" accept='image/*'
                                (change)="addImageToForm('favicon', $event)" label="SELECTEREN">
                            <div class="_image-container" *ngIf="tenantForm.get('favicon').value">
                                <img [src]="tenantForm.get('favicon').value" />
                            </div>
                        </div>
                    </div>
                </div>

                <p class="_small-title _small-sub-title" [translate]="'TENANT.CONTACT'"></p>
                <div class="_data-container">
                    <div class="_data _half">
                        <form-input label="{{ 'TENANT.EMAIL' | translate }}"
                            [formControl]="tenantForm.get('email') | cast"></form-input>
                    </div>
                    <div class="_data _half">
                        <form-input label="{{ 'TENANT.TELEPHONE' | translate }}"
                            [formControl]="tenantForm.get('telephone') | cast"></form-input>
                    </div>
                </div>

                <p class="_small-title _small-sub-title" [translate]="'TENANT.ADDRESS'"></p>
                <div class="_data-container">
                    <form-full-address style="width: 100%;"
                        [formGroup]="tenantForm.get('Address') | cast"></form-full-address>
                </div>

                <p class="_small-title _small-sub-title" [translate]="'TENANT.INTRO'"></p>
                <p class="_subtitle" [translate]="'TENANT.INTRO_EXPLANATION'"></p>
                <div class="_data-container">
                    <editor-component [template]="tenantForm.get('intro').value" [variables]="[]" [type]="'text'"></editor-component>
                </div>

                <div class="_buttons" *ifUserHasPermissions="[UserPermissions.WriteTenants]">
                    <button type="button" class="_button _save-button" (click)="update()"><span>{{ 'TENANT.UPDATE' | translate}}</span></button>
                </div>
            </div>
        </div>


        <!-- Tenant Communication Templates -->
        <div class="_segmented-component" *ngSwitchCase="getSegmentName(this.segments[1])">

            <div class="_container _communication-templates-container">

                <p class="_title" [translate]="'COMMUNICATION_TEMPLATE.TITLE'"></p>
                <p class="_subtitle" [translate]="'COMMUNICATION_TEMPLATE.SUBTITLE'"></p>

                <div class="_communication-template-disclaimer">
                    <p class="_disclaimer-title" [translate]="'COMMUNICATION_TEMPLATE.DISCLAIMER_TITLE'"></p>
                    <p [translate]="'COMMUNICATION_TEMPLATE.DISCLAIMER'"></p>
                </div>

                @for (group of groupedCommunicationTemplates | keyvalue | orderBy:['value']:['desc']; track group.key) {

                    <div class="_communication-template-group">

                        <div class="_communication-template-group-title">
                            <p class="_title">{{('COMMUNICATION_MESSAGE_TYPE_GROUP.' + group.key | uppercase) | translate}}</p>

                            @if (group.key.includes('reservation')) {
                                <div class="_add-template-button" (click)="openCommunicationTemplate('custom', null, $any('custom-'+group.key.replace('_', '-')))">
                                    <ion-icon src="./assets/icons/add-outline.svg"></ion-icon>
                                    <p> {{'COMMUNICATION_TEMPLATE.ADD_CUSTOM_TEMPLATE' | translate}}</p>
                                </div>
                            }
                        </div>

                        @for (messageTypeArray of group.value; track messageTypeArray) {

                            <div class="_communication-message-type">
                                @for (messageType of (messageTypeArray | keyvalue | orderBy:['key']:['asc']); track messageType) {

                                    @if (messageType.value[0]?.customName) {
                                        <p class="_message-type-title"><b>{{'COMMUNICATION_TEMPLATE.CUSTOM_TEMPLATE' | translate}}:</b> {{messageType.value[0]?.customName}}</p>
                                    } @else {
                                        <p class="_message-type-title" innerHTML="{{'RICH_COMMUNICATION_MESSAGE_TYPE.' + messageType.key | uppercase | translate}}"></p>
                                    }
    
                                    <div class="_communication-template-container">
    
                                        @for (communicationTemplate of messageType.value; track communicationTemplate.id) {
                                            <div 
                                                class="_communication-template" 
                                                [ngClass]="communicationTemplate.channel" 
                                                (click)="openCommunicationTemplate(communicationTemplate.customName ? 'custom' : 'standard', communicationTemplate.id, communicationTemplate.messageType)"
                                            >
                                                <ion-icon src="./assets/icons/{{communicationTemplate.channel}}-outline.svg"></ion-icon>
                                                <p> {{'COMMUNICATION_ENDPOINTS.' + communicationTemplate.endpoint | uppercase | translate}}</p>
                                                <ion-toggle 
                                                    (click)="$event.stopPropagation()" 
                                                    (ionChange)="toggleCommunicationTemplateEnabled(communicationTemplate, $event)" 
                                                    [(ngModel)]="communicationTemplate.isEnabled"
                                                    color="{{communicationTemplate.channel === 'sms' ? 'warning' : 'tertiary'}}">
                                                </ion-toggle>
                                            </div>
                                        }
    
                                    </div>
                                    
                                }
                            </div>
                            
                        }

                    </div>

                }

            </div>
        </div>

        <!-- Tenant Loan Contract Template -->
        <div class="_segmented-component" *ngSwitchCase="getSegmentName(this.segments[2])">

            <div class="_container" *ngIf="loanContractTemplate">
                <div class="_loan-contract-template-container">
                    <div class="_editor-container">
                        <editor-component [template]="loanContractTemplate.template.html" [variables]="loanContractTemplate.variables" [type]="'contract'"></editor-component>
                    </div>                   
                </div>
                <div class="_buttons" *ifUserHasPermissions="[UserPermissions.WriteTenants]">
                    <button type="button" class="_button _save-button" (click)="updateLoanContractTemplate()">
                        <span>{{ 'COMMUNICATION_TEMPLATE.UPDATE' | translate}}</span>
                    </button>
                </div>
            </div>
        </div>

        <!-- Tenant Permission groups -->
        <div class="_segmented-component" *ngSwitchCase="getSegmentName(this.segments[3])">

            <ng-container *ifUserHasPermissions="[UserPermissions.WriteTenants]">
                <permission-groups-component *ngIf="permissionGroupForm" [form]="permissionGroupForm" [type]="'update-permission-group'"></permission-groups-component>
            </ng-container>
           
        </div>

        <!-- UiT Database -->
        <div class="_segmented-component " *ngSwitchCase="getSegmentName(this.segments[4])">

            <div class="_container _uit-database-container">

                <img class="_uit-database-logo" src="./assets/imgs/UiTinVlaanderen_horizontaal_grijs.png" alt="UiTinVlaanderen Logo" description="UiTinVlaanderen Logo" />

                <div class="_content-container">
                    <p class="_title" [translate]="'TENANT.UIT_DATABASE.TITLE'"></p>
                    <p class="_uit-database-explanation" [translate]="'TENANT.UIT_DATABASE.EXPLANATION'"></p>
                    <p class="_uit-database-disclaimer" [translate]="'TENANT.UIT_DATABASE.DISCLAIMER'"></p>

                    <p class="_small-title _small-sub-title" [translate]="'TENANT.UIT_DATABASE.SELECTED_ORGANIZER'"></p>
                    <div class="_data-container _selected-organizer-container">
                        <p *ngIf="!tenant?.Organizer" [translate]="'TENANT.UIT_DATABASE.NO_SELECTED_ORGANIZER'"></p>
                        <div class="_selected-organizer" *ngIf="tenant?.Organizer">
                            <p>
                                <b>{{tenant.Organizer.name}}</b> 
                                (<a href="{{tenant.Organizer.website}}" target="_blank">{{tenant.Organizer.website}}</a>)
                            </p>
                            <ion-icon 
                                src="./assets/icons/absent-outline.svg" 
                                tooltip="{{'TENANT.UIT_DATABASE.REMOVE_SELECTED_ORGANIZER' | translate}}" 
                                [options]="{ 'hide-delay': 0, theme: 'light' }" 
                                (click)="removeSelectedUiTDatabaseOrganizer()"
                            ></ion-icon>
                        </div>
                    </div>

                    <ng-container *ngIf="organizerImageForm && tenant?.Organizer">
                        <p class="_small-title _small-sub-title" [translate]="'TENANT.UIT_DATABASE.IMAGE'"></p>
                        <div class="_data-container _images-container">
                            <div class="_data _full">
                                <div class="_upload-container">
                                    <p class="_image-disclaimer" [translate]="'TENANT.UIT_DATABASE.IMAGE_SELECT'"></p>
                                    <input name="file" id="file" type="file" class="file-input" accept='image/*' (change)="updateOrganizerImage($event)" label="SELECTEREN">
                                    <div class="_image-container" *ngIf="organizerImageForm.get('image').value">
                                        <img [src]="organizerImageForm.get('image').value" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <p class="_small-title _small-sub-title" [translate]="'TENANT.UIT_DATABASE.LABELS'"></p>
                        <div class="_uit-database-labels-container">
                            <p class="_label-explanation" [translate]="'TENANT.UIT_DATABASE.LABELS_EXPLANATION'"></p>
                            <div class="_labels-container">
                                <div class="_label-container" *ngFor="let label of uitDatabaseLabels">
                                    <div class="_label-segment">
                                        <span class="_label-name">{{label.name}}</span>
                                    </div>
                                    <div class="_label-segment _label-action-container" (click)="createOrUpdateUiTDatabaseLabel(label)">
                                        <ion-icon src="./assets/icons/edit-outline.svg"></ion-icon>
                                    </div>
                                    <div class="_label-segment _label-action-container" (click)="deleteUiTDatabaseLabel(label)">
                                        <ion-icon src="./assets/icons/trash-outline.svg"></ion-icon>
                                    </div>
                                </div>
                                <div class="_label-container _create-label-container" (click)="createOrUpdateUiTDatabaseLabel()">
                                    <ion-icon src="./assets/icons/add-outline.svg"></ion-icon>
			                        <span >{{ 'UIT_DATABASE_LABEL.CREATE' | translate}}</span>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <div class="_organizer-selection-options-container">
                        <div class="_organizer-selection-option-container">
                            <p class="_small-title _small-sub-title" [translate]="'TENANT.UIT_DATABASE.SEARCH_ORGANIZER'"></p>
                            <search-organizer 
                                label="{{'TENANT.UIT_DATABASE.SEARCH_ON_NAME' | translate}}" 
                                type="search" 
                                (selected)="selectUiTDatabaseOrganizer($event)" 
                                (hasSearchedChanged)="hasSearchedUiTDatabaseOrganizerChanged($event)">
                            </search-organizer>
                        </div>
                        
                        <div class="_organizer-selection-option-container" *ngIf="(tenant?.Organizer || hasSearchedUiTDatabaseOrganizer) && organizerForm">
                            <p class="_small-title _small-sub-title" [translate]="'TENANT.UIT_DATABASE.CREATE_ORGANIZER'"></p>
                            <div class="_create-organisator-container">
                                <p [translate]="'TENANT.UIT_DATABASE.CREATE_ORGANIZER_EXTRA_DISCLAIMER'"></p>
                                <div class="_data-container">
                                    <div class="_data _full">
                                        <form-input label="{{ 'TENANT.UIT_DATABASE.ORGANIZER_NAME' | translate }}" [formControl]="organizerForm.get('name') | cast"></form-input>
                                    </div>
                                    <div class="_data _full">
                                        <form-input label="{{ 'TENANT.UIT_DATABASE.ORGANIZER_WEBSITE' | translate }}" [formControl]="organizerForm.get('website') | cast"></form-input>
                                    </div>
                                </div>
                                <div class="_buttons" *ifUserHasPermissions="[UserPermissions.WriteTenants]">
                                    <button type="button" class="_button _save-button" (click)="createAndSelectUiTDatabaseOrganizer()">
                                        <span>{{ 'TENANT.UIT_DATABASE.CREATE_ORGANIZER_BUTTON' | translate}}</span>
                                    </button>
                                </div>
                            </div>
                           
                        </div>
    
                       
                    </div>

                </div>                
            </div>
        </div>

    </ng-container>

</div>